import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export function LegalLayout({ title, updated, children, otherTo, otherLabel }) {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="border-b border-gray-100 sticky top-0 z-20 bg-white/90 backdrop-blur">
        <div className="max-w-3xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-[#5aa469] transition-colors" data-testid="legal-back">
            <ArrowLeft className="h-4 w-4" /> Torna al sito
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-14">
        <h1 className="font-display font-bold text-4xl sm:text-5xl mb-3">{title}</h1>
        <p className="text-sm text-gray-400 mb-10">Ultimo aggiornamento: {updated}</p>
        <div className="mo-legal space-y-8 text-gray-700 leading-relaxed">{children}</div>

        <div className="mt-14 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to={otherTo} className="text-[#5aa469] font-medium hover:underline" data-testid="legal-other-link">{otherLabel}</Link>
          <a href="mailto:creamenuone@gmail.com" className="text-sm text-gray-500 hover:text-[#5aa469] transition-colors">creamenuone@gmail.com</a>
        </div>
      </main>
    </div>
  );
}

export function Section({ n, title, children }) {
  return (
    <section>
      <h2 className="font-display font-semibold text-2xl text-gray-900 mb-3">{n}. {title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
